export function planTopicDrillTimer({
  lsatPractice,
  taraWritingPractice,
  lnatWritingPractice,
  timed,
  minutes,
} = {}) {
  if (!timed) return { kind: 'stopTimer' };
  if (lsatPractice) {
    return { kind: 'startTimer', minutes: 35 };
  }
  if (taraWritingPractice) {
    const mins = Number(minutes);
    return { kind: 'startTimer', minutes: Number.isFinite(mins) && mins > 0 ? mins : 40 };
  }
  if (lnatWritingPractice) {
    const mins = Number(minutes);
    return {
      kind: 'initializeTimerOnly',
      minutes: Number.isFinite(mins) && mins > 0 ? mins : 40,
    };
  }
  const mins = Number(minutes);
  return { kind: 'startTimer', minutes: Number.isFinite(mins) && mins > 0 ? mins : null };
}
